
<div class="multi-content">
    <nz-divider class="table-divider"></nz-divider>
    <div class="button-table-action">
        <button nz-button [disabled]="dataMultiTable.length == 0 || !hasSelect" (click)="removeItens()">
            <nz-icon nzType="delete" />{{'meli.multitable.removeSelected'|translateTA}}
        </button>
        <span class="spacer"></span>
        <div class="info data">{{ selectedCount }} / {{ dataMultiTable.length }} </div>
    </div>
    <nz-divider class="table-divider"></nz-divider>
    <div class="table-multi">
        <div class="header-line">
            <div class="grid-row header-row" [style.gridTemplateColumns]="'repeat(' + colsCount + ', minmax(0, 1fr))'">
                <div class="checkbox-col">
                    <label nz-checkbox [ngModel]="allComplete" [nzIndeterminate]="someComplete()"
                        (ngModelChange)="onSelectCheckBox($event)"></label>
                </div>
                <div class="grid-cell" *ngFor="let column of dataMultiTableConfig"
                    [style.gridColumn]="'span ' + column.colspan" nz-tooltip [nzTooltipTitle]="column.columnDesc">
                    <div class="header">{{column.columnDesc}}</div>
                </div>
            </div>
        </div>
        <div class="variation-grid" #grid>
            <div *ngFor="let data of dataMultiTable" class="lines">
                <div class="grid-row" [style.gridTemplateColumns]="'repeat(' + colsCount + ', minmax(0, 1fr))'">
                    <div class="checkbox-col">
                        <label nz-checkbox [(ngModel)]="data.selected" (ngModelChange)="updateAllComplete()"></label>
                    </div>
                    <div class="grid-cell" *ngFor="let column of dataMultiTableConfig|arrayFilter:'columnName':'selecionar':true"
                        [style.gridColumn]="'span ' + column.colspan">

                        <div class="data-text" *ngIf="column.format=='TEXT'" nz-tooltip [nzTooltipTitle]="data[column.columnName]">
                            {{data[column.columnName]}}
                        </div>

                        <div class="data-int" *ngIf="column.format=='INT'">
                            {{data[column.columnName] | number : '1.0-0'}}
                        </div>

                        <div class="data-float" *ngIf="column.format=='FLOAT'">
                            {{data[column.columnName]| number : '1.2-2':'br'}}
                        </div>

                        <div class="data-date" *ngIf="column.format=='DATE'">
                            {{data[column.columnName]| dateFormatPipe2 : column.dateFromFormat: column.dateFormat}}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
